import { Component, OnInit } from '@angular/core';
import {ActivationRequest, Affiliate, ApiService, PropertyType, Software, SoftwaresList} from '../api/api.service';
import {LayoutManagerService} from '../layout-manager.service';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from '../auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {StorageService} from '../api/storage.service';
import {TranslateService} from '@ngx-translate/core';
import {SessionsService} from '../sessions.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {catchError} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {MatChipInputEvent} from '@angular/material/chips';
import {CreateSoftwareDialogComponent} from './create-software-dialog/create-software-dialog.component';

@Component({
  selector: 'app-partner-manager',
  templateUrl: './partner-manager.component.html',
  styleUrls: ['./partner-manager.component.css']
})
export class PartnerManagerComponent implements OnInit {

  updating = false;
  changes = false;
  logoutClicked = false;
  softwares: SoftwaresList;
  uploadedSoftwares = [];
  requests: ActivationRequest;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  affiliates: Affiliate[];

  public totalPayments: TotalPayments[] = [];
  //displayedColumns: string[] = ['Utente', 'Software', 'Data', 'Import', "Percentuale Applicabile", "Storno"];
  displayedColumns: string[] = ['user', 'software', 'date', 'import', "perc", "storno"];

  importoTotale: number;

  options: string[] = ['int', 'long', 'float', 'string', 'boolean'];
  propOption = 'string';

  constructor(
    public layoutManager: LayoutManagerService,
    private cookieService: CookieService,
    private auth: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackBar: MatSnackBar,
    private api:ApiService,
    private dialog: MatDialog,
    public sessions: SessionsService,
    private storage: StorageService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.softwares = this.activatedRoute.snapshot.data.softwares;
    this.requests = this.activatedRoute.snapshot.data.requests;
    this.affiliates = this.activatedRoute.snapshot.data.affiliates;

    this.registerAllPayments();

    this.softwares.softwares.forEach(soft => {
      this.checkUploadedSoftware(soft.software_name.replace(' ', '_').toLowerCase())
    });
  }

  getSoftwareActivation(userAccess: string, softwareName: string): boolean {
    const slist = JSON.parse(atob(userAccess));
    let soft;
    for (let s of slist) {
      if (s.software_name.toLowerCase() == softwareName.toLowerCase())
        soft = s;
    }
    return soft.activation;
  }

  addOption(name:string, type:string, value:string, software: Software) {
    if (name.length > 0 && value.length > 0) {
      let finded = false;
      for (let item of software.properties)
        if (item.name == name)
          finded = true;
      if (!finded) {
        let typeEn: PropertyType;
        switch (type) {
          case 'int':
            typeEn = PropertyType.int;
            break;
          case 'float':
            typeEn = PropertyType.float;
            break;
          case 'long':
            typeEn = PropertyType.long;
            break;
          case 'string':
            typeEn = PropertyType.string;
            break;
          case 'boolean':
            typeEn = PropertyType.boolean;
            break;
        }
        software.properties.push({
          name: name,
          value: value,
          type: typeEn
        })
      }
    }
    this.changes = true;
    this.saveChanges()
  }

  removeOption(name:string, software: Software) {
    software.properties.forEach(option => {
      if (option.name == name)
        software.properties.splice(software.properties.indexOf(option),1)
    });
    this.changes = true;
    this.saveChanges()
  }

  registerAllPayments() {
    this.importoTotale = 0;
    this.affiliates.forEach(aff => {
      aff.softwares.forEach(soft => {
        soft.payment_recieved.forEach(payment => {
          this.importoTotale += parseFloat(payment.importo.replace("EUR",""))*parseFloat(payment.storno)*0.01;
          this.totalPayments.push({
            user: atob(aff.email),
            software: soft.software.software_name,
            date: payment.data,
            import: payment.importo,
            perc: payment.storno,
            storno: this.getStorno(payment)
          })
        })
      })
    })
  }

  getStorno(payment) {
    const total = parseFloat(payment.importo.replace("EUR", ""))*(parseFloat(payment.storno)*0.01);
    return total.toString();
  }

  getSoftwareByName(name: string): Software {
    for (let soft of this.softwares.softwares) {
      if (soft.software_name == name)
        return soft;
    }
    return null;
  }

  acceptRequest(req) {
    if(!this.updating) {
      this.updating = true;
      this.api.acceptActivtionRequests(req.request_id).subscribe(response => {
        this.updating = false;
        this.updateRequests()
      });
    }
  }

  deleteRequest(req) {
    if(!this.updating) {
      this.updating = true;
      this.api.deleteActivtionRequests(req.request_id).subscribe(response => {
        this.updating = false;
        this.updateRequests()
      });
    }
  }

  updateRequests() {
    this.api.getActivtionRequests().subscribe(resp => {
      this.requests = resp;
    })
  }

  openUploadDialog(name: string): void {
    /*if (!this.changes) {
      const dialogRef = this.dialog.open(UploadSoftwareDialogComponent, {
        height: '300px',
        width: '400px',
        data: { software_name: name }
      });

      dialogRef.afterClosed().subscribe((result: Software) => {
        this.reloadSoftwares()
      });
    }else {

    }*/
  }

  basetos(src: string): string {
    return atob(src);
  }

  stobase(src: string) : string {
    return encodeURI(src)
  }

  download(software: string) {
    this.storage.getSoftware(software).subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/zip'
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    });
  }

  getUploadedState(name: string) {
    for(let soft of this.uploadedSoftwares) {
      if (soft.name == name)
        return soft.uploaded;
    }
    return false;
  }

  checkUploadedSoftware(name: string) {
    this.updating = true;
    this.storage.getSoftware(name)
      .pipe(
        catchError(this.handleError(name, []))
      )
      .subscribe(response => {
        if (response!= null) {
          this.uploadedSoftwares.push({
            name : name,
            uploaded: true
          })
        }
        this.updating = false;
      });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.uploadedSoftwares.push({
        name : operation,
        uploaded: false
      });
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  openDialog(): void {
    if (!this.changes) {
      const dialogRef = this.dialog.open(CreateSoftwareDialogComponent, {
        height: '600px',
        width: '800px'
      });

      dialogRef.afterClosed().subscribe((result: Software) => {
        if (result != undefined) {
          result.email = this.sessions.getNameUser();
          this.api.createPartnerSoftwareIstance(result).subscribe(response => {
            if (response.result) {
              this.reloadSoftwares();
            }else {
              this.openSnackBar(this.translateService.instant('snackbar-message-5') + response.message);
            }
          })
        }
      });
    }else {
      this.openSnackBar(this.translateService.instant('snackbar-message-4'))
    }
  }

  getVersionsArray(versions: string) {
    let versionsRet = versions.split(",");
    const nulRet = [];
    if(versionsRet[0]=="" && versionsRet.length == 1)
      return nulRet;
    return versionsRet
  }

  priceChanges(box: HTMLInputElement, soft: Software) {
    soft.price = box.value;
  }

  shDescrChanges(box: HTMLInputElement, soft: Software) {
    const name = box.value;
    soft.short_description = btoa(name);
  }

  descrChanges(box, soft: Software) {
    const name = box.value;
    soft.description = btoa(name);
  }

  saveChanges() {
    this.changes = false;
    this.softwares.softwares.forEach(software => {
      this.updateSoftware(software);
    });
  }

  addVersion(software: Software, event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    const versions = software.versions.split(",");
    if (versions.indexOf(value.trim()) >= 0 || value.trim() == "") {
      if(value.trim() != "")
        this.openSnackBar(this.translateService.instant('snackbar-message-3'))
    } else {
      if ((value || '').trim()) {
        versions.push(value.trim());
        let result = '';
        versions.forEach(vers => {
          if (vers != "")
            result += vers+',';
        });
        if(result.length > 0)
          result = result.substr(0, result.length-1);
        console.log(result);
        software.versions = result;
        this.updateSoftware(software)
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeVersion(software: Software, version: string) {
    const versions = software.versions.split(",");
    let result = "";
    versions.forEach(vers => {
      if (vers != version && vers != "")
        result+=vers+",";
    });
    if(result.length > 0)
      result = result.substr(0, result.length-1);
    software.versions = result;
    this.updateSoftware(software)
  }

  updateSoftware(soft: Software) {
    soft.price = soft.price.replace(',','.');
    this.api.updateSoftwareIstance(soft).subscribe(response => {
      this.changes = false;
      if (!response.result)
        this.openSnackBar(this.translateService.instant('snackbar-message-2'));
    })
  }

  reloadSoftwares() {
    if(!this.updating) {
      this.updating = true;
      this.api.getPartnerSoftwaresList().subscribe(response => {
        this.softwares = response;
        this.uploadedSoftwares = [];
        response.softwares.forEach(soft => {
          this.checkUploadedSoftware(soft.software_name.replace(' ', '_').toLowerCase());
        });
        this.updating = false;
      })
    }
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    this.snackBar.open(message, this.translateService.instant('login.snackbar-action-1'), config);
  }

  logout() {
    if (this.changes && !this.logoutClicked) {
      this.openSnackBar(this.translateService.instant('snackbar-message-1'));
      this.logoutClicked = true
    }else {
      this.cookieService.set('email', '');
      this.cookieService.set('password', '');
      this.auth.doSignOutUser();
      this.router.navigateByUrl('/login');
    }
  }
}

export interface TotalPayments {
  user: string,
  software: string,
  date: string,
  import: string,
  perc: string,
  storno: string
}
